// src/utils/colorUtils.ts
export const generateColorPalette = (baseColor: string) => {
	// Convert hex to RGB
	const hexToRgb = (hex: string) => {
		const r = Number.parseInt(hex.slice(1, 3), 16);
		const g = Number.parseInt(hex.slice(3, 5), 16);
		const b = Number.parseInt(hex.slice(5, 7), 16);
		return [r, g, b];
	};

	// Convert RGB to hex
	const rgbToHex = (r: number, g: number, b: number) => {
		return "#" + [r, g, b].map((x) => x.toString(16).padStart(2, "0")).join("");
	};

	// Lighten or darken color
	const adjustColor = (color: string, amount: number) => {
		const [r, g, b] = hexToRgb(color);
		return rgbToHex(
			Math.min(255, Math.max(0, r + amount)),
			Math.min(255, Math.max(0, g + amount)),
			Math.min(255, Math.max(0, b + amount)),
		);
	};

	// Generate 9 shades from light to dark
	const palette = [];
	for (let i = 4; i >= 0; i--) {
		palette.push(adjustColor(baseColor, -i * 20));
	}
	for (let i = 1; i <= 4; i++) {
		palette.push(adjustColor(baseColor, i * 20));
	}

	return palette.sort((a, b) => {
		// Sort from dark to light
		const luminanceA = hexToRgb(a).reduce((sum, x) => sum + x, 0);
		const luminanceB = hexToRgb(b).reduce((sum, x) => sum + x, 0);
		return luminanceB - luminanceA;
	});
};

// Define color presets once
// src/utils/colorUtils.ts
export const COLOR_PRESETS = {
  green: generateColorPalette("#6eb15c"),
  pink: generateColorPalette("#ea56c4"),
  blue: generateColorPalette("#008080"),
  red: generateColorPalette("#dc2626"),
  purple: generateColorPalette("#6d28d9"),
  orange: generateColorPalette("#f97316"),
  teal: generateColorPalette("#0d9488"),
  tencolor1: ["#9a97f1ff", // primary1
    "#e39a9cff", // primary2
    "#4cceac",   // primary3
    "#6870fa",   // primary4
    "#e29adbff", // secondary1
    "#a8dfeaff", // secondary2
    "#eabc90ff", // secondary3
    "#98dd98ff", // secondary4
    "#95bcd5ff" ],
  grouped1: [
    "#6e6d85ff", // primary1
    "#be5256ff", // primary2
    "#18dda8ff",   // primary3
    "#80694dff",   // primary4
    "#8c6588ff", // secondary1
    "#2c4e55ff", // secondary2
    "#6c4e31ff", // secondary3
    "#2a682aff", // secondary4
    "#647d8fff"  // secondary5
  ],

} as const;
export type ColorPresetName = keyof typeof COLOR_PRESETS;